import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import { node, number, bool, string } from 'prop-types';

import { selectCollapsedSidebar } from 'modules/sidebar';

import 'resources/styles/vendor/grid';
import topBarStyles from 'shared-components/TopBar/styles/index.scss';
import sideBarStyles from 'shared-components/SideBar/styles/index.scss';

@connect((state) => ({
  isCollapsedSidebar: selectCollapsedSidebar(state),
}))
class Container extends React.Component {
  render() {
    const {
      children,
      className,
      appBarOffset,
      topBarOffset,
      sideBarOffset,
      isCollapsedSidebar,
      ...props
    } = this.props;

    const sideBarStyle = isCollapsedSidebar
      ? sideBarStyles['has-sidebar-offset--collapsed']
      : sideBarStyles['has-sidebar-offset'];

    return (
      <div
        className={cx({
          [topBarStyles['has-appbar-offset']]: appBarOffset,
          [topBarStyles['has-topbar-offset']]: topBarOffset,
          [sideBarStyle]: sideBarOffset,
        })}
        style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      >
        <div
          className={cx('container', className)}
          style={{
            height: 'calc(100% - 50px)',
            position: 'relative',
            overflow: 'auto',
          }}
          {...props}
        >
          {children}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 50,
          }}
        >
          <a
            href="https://www.veritone.com/privacy/"
            target="_blank"
            style={{ fontSize: 11 }}
            data-test="privacy-policy-link"
          >
            Privacy Policy
          </a>
          <div style={{ margin: '0 10px' }}>-</div>
          <a
            href="https://docs.veritone.com/#/terms-and-conditions/?id=veritone-developer-terms-amp-conditions"
            target="_blank"
            style={{ fontSize: 11 }}
            data-test="terms-and-conditions-link"
          >
            Terms & Conditions
          </a>
        </div>
      </div>
    );
  }
}

Container.propTypes = {
  children: node,
  className: string,
  topBarOffset: bool,
  sideBarOffset: bool,
  appBarOffset: bool,
  isCollapsedSidebar: bool,
};

const Row = ({ children, className, ...props }) => (
  <div className={cx('row', className)} {...props}>
    {children}
  </div>
);

Row.propTypes = {
  children: node,
  className: string,
};

const Col = ({ children, lg, sm, hiddenSm, className, ...props }) => {
  const colClass = `col-${lg}`;
  const colSmClass = `col-${sm}-sm`;
  const hiddenSmClass = 'hidden-sm';

  const classes = cx(
    lg && colClass,
    sm && colSmClass,
    hiddenSm && hiddenSmClass,
    className
  );

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

Col.propTypes = {
  children: node,
  lg: number,
  sm: number,
  hiddenSm: bool,
  className: string,
};

export { Container, Row, Col };



// WEBPACK FOOTER //
// ./src/client/shared-components/grid/index.js